import { Button, useMutation, useNotify, useRefresh } from "react-admin";
import { useFormState } from "react-final-form";

const UpdateStatusButton = () => {
  const { values } = useFormState();
  const notify = useNotify();
  const refresh = useRefresh();

  const [handleUpdateChangeRequest, { loading }] = useMutation(
    {
      type: "update",
      resource: `changeRequestForms`,
      payload: {
        id: values.id,
        data: values,
      },
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully update change request status.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed update change request status, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={handleUpdateChangeRequest}
      color="secondary"
      label={loading ? `Loading...` : `Save`}
    />
  );
};

export default UpdateStatusButton;
